import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as s, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconScissors",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.881 6.887a.5.5 0 0 1 .707 0l2.766 2.76a.5.5 0 0 1-.707.707l-2.765-2.76a.5.5 0 0 1 0-.707Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 3a2 2 0 1 1 3.723 1.016L6 5.293l3.647-3.647a.5.5 0 1 1 .707.708l-5.63 5.63a2 2 0 1 1-.707-.707L5.292 6 4.016 4.723A2 2 0 0 1 1 3Zm1 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  fill: "currentColor"
}, null, -1), m = [
  _,
  u
];
function f(a, p, i, h, v, e) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--scissors"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Scissors",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const C = /* @__PURE__ */ o(n, [["render", f]]);
export {
  C as default
};
//# sourceMappingURL=scissors.js.map
